/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ArrowLeft from '@material-ui/icons/ArrowBackIos';
import ArrowRight from '@material-ui/icons/ArrowForwardIos';
import Button from '@material-ui/core/Button';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';

const { PERSIST_KEY } = configENV;

const Pagination = (props) => {
    const {
        currentPage, occasionId, orderId, totalPage, handleGiftListPaginationChanged,
    } = props;
    const prevPage = currentPage - 1;
    const nextPage = currentPage + 1;
    const prevPageEnabled = currentPage > 1;
    const nextPageEnabled = currentPage < totalPage;

    if (totalPage === 1) return null;

    return (
        <>
            <div className="margin-top split align-center">
                <Button
                    className="prev-button"
                    onClick={(event) => handleGiftListPaginationChanged(event, occasionId, prevPage, orderId)}
                    disabled={!prevPageEnabled}
                >
                    <ArrowLeft />
                </Button>
                <div style={{ minWidth: '180px' }}>
                    Page <span className="item-from">{currentPage}</span> of{' '}
                    <span className="item-total">{totalPage}</span>
                </div>
                <Button
                    className="next-button"
                    onClick={(event) => handleGiftListPaginationChanged(event, occasionId, nextPage, orderId)}
                    disabled={!nextPageEnabled}
                >
                    <ArrowRight />
                </Button>
            </div>
        </>
    );
};

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    occasionId: PropTypes.string.isRequired,
    orderId: PropTypes.string.isRequired,
    totalPage: PropTypes.number.isRequired,
    handleGiftListPaginationChanged: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        currentPage: newState.giftList.currentPage, // use this to update the component
        orderId: newState.giftList.orderId,
        totalPage: newState.giftList.totalPage,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListPaginationChanged: (event, occasionId, newPage, orderId) => dispatch(EventDispatcher.handleGiftListPaginationChanged(event, occasionId, newPage, orderId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Pagination);
